import { Account } from "callable-data-objects";
import { DBReference } from "callable-data-objects/dist/models/accountDevice/AccountDevice";
import { useAccount } from "Hooks/Endpoints";
import React, { useEffect, useState } from "react";
import { Dropdown } from "semantic-ui-react";

const AccountSelectWithContext = ({
  name,
  value,
  onChange,
  style = {},
}: any) => {
  const { listAccounts: accounts } = useAccount();
  const [currentValue, setCurrentValue] = useState<any>(value);

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  const opts = accounts.map((org: Account) => {
    return {
      text: org.name,
      value: org.id,
    };
  });

  return (
    <Dropdown
      fluid
      search
      selection
      clearable
      options={opts}
      name={name}
      value={currentValue ? currentValue : ""}
      placeholder='Select Account'
      style={style}
      onChange={(event, { value }) => {
        const org = accounts.find((org: Account) => org.id === value);
        if (org) {
          const dbRef: DBReference = {
            id: org.id,
            name: org.name,
          };
          onChange(dbRef);
        } else {
          onChange(undefined);
        }
      }}
    />
  );
};

export default AccountSelectWithContext;
